export const ZERO_CACHE = 0;
export const MINUTE_CACHE = 60 * 1000;
export const FIVE_MINUTE_CACHE = 5 * MINUTE_CACHE;
export const HOUR_CACHE = 60 * MINUTE_CACHE;
export const DAY_CACHE = HOUR_CACHE * 24;
